import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    // background:'lightblue',
    // padding:10
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
    padding: 10,
    color: "#0D0D39",
  },
  tableContainer: {
    maxHeight:460
  },
  userTableContainer: {
    maxHeight:390
  },
  tableHead: {
    backgroundColor: "white",
    border: "none",
    fontWeight: "bold",
    color: "#0D0D39",
    textTransform: "capitalize",
    fontSize: 14,
    paddingTop: 10,
    paddingBottom: 20,
  },
  tableCell: {
    border: "none",
    opacity: 0.9,
    fontSize: 12,
    color: "#4B686E",
    textTransform: "capitalize",
  },
  actionCell: {
    opacity:1,
    display:'flex',
    alignItems:'center'
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  actionIcon:{
    fontSize:20,
    marginLeft:10,
  }
}));
